import { render, staticRenderFns } from "./VerticalRuler.vue?vue&type=template&id=8882616e&scoped=true"
var script = {}
import style0 from "./VerticalRuler.vue?vue&type=style&index=0&id=8882616e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8882616e",
  null
  
)

export default component.exports